// src/pages/AccesClientsMH.js
import React, { useState } from "react";
import CLIENTS_MH from "../data/clientsMH";
import useSEO from "../seo/useSEO";
import "../index.css";

export default function AccesClientsMH() {
  useSEO({
    title: "Accès clients",
    description:
      "Espace privé pour mes clients : saisissez votre code pour accéder à votre galerie et télécharger vos photos.",
    canonical: "/acces-clients",
    image: "/images/og-default.jpg",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: "Accès clients",
      url: "https://www.maximeh.lu/acces-clients",
    },
  });

  const [code, setCode] = useState("");
  const [client, setClient] = useState(null);
  const [error, setError] = useState("");

  const onSubmit = (e) => {
    e.preventDefault();
    const found = CLIENTS_MH.find(
      c => c.code && c.code.toLowerCase() === code.trim().toLowerCase()
    );
    if (found) {
      setClient(found);
      setError("");
    } else {
      setClient(null);
      setError("Code invalide. Vérifiez et réessayez.");
    }
  };

  return (
    <section className="clients-access" style={{ maxWidth: 680, margin: "40px auto", padding: "0 16px" }}>
      <h1 style={{ textAlign: "center", marginBottom: 10 }}>Accès clients</h1>
      <p style={{ textAlign: "center", color: "#555", marginBottom: 18 }}>
        Entrez votre code pour consulter et télécharger vos photos.
      </p>

      {/* Formulaire code */}
      {!client && (
        <form onSubmit={onSubmit} style={{ display: "grid", gap: 10, margin: "0 auto 18px", maxWidth: 420 }}>
          <label htmlFor="code" style={{ fontWeight: 600 }}>Votre code</label>
          <input
            id="code"
            type="text"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder="Ex. MH_1234"
            required
            style={{ padding: 10, borderRadius: 8, border: "1px solid #ddd", fontSize: 16 }}
          />
          <button type="submit" className="btn-solid" style={{ padding: "10px 16px", borderRadius: 999 }}>
            Accéder
          </button>
          {error && <p style={{ color: "#c00", marginTop: 4 }}>{error}</p>}
        </form>
      )}

      {/* Résultat */}
      {client && (
        <div className="client-panel" style={{ background: "#fff", border: "1px solid #eee", borderRadius: 12, padding: 18 }}>
          <h2 style={{ marginTop: 0 }}>{client.name}</h2>
          <p style={{ color: "#555" }}>
            Voici votre espace sécurisé. Vous pouvez ouvrir la galerie ou télécharger vos fichiers.
          </p>

          <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginTop: 10 }}>
            {client.pcloudLink && (
              <a
                className="btn-solid"
                href={client.pcloudLink}
                target="_blank"
                rel="noreferrer"
                style={{ textDecoration: "none" }}
              >
                Ouvrir la galerie
              </a>
            )}

            {client.zip && client.zip.trim() !== "" && (
              <a
                className="btn-ghost"
                href={client.zip}
                target="_blank"
                rel="noreferrer"
                style={{ textDecoration: "none" }}
              >
                Télécharger le .zip
              </a>
            )}
          </div>

          <button
            onClick={() => { setClient(null); setCode(""); }}
            className="btn-ghost"
            style={{ marginTop: 14 }}
          >
            Changer de code
          </button>
        </div>
      )}

      {/* Support */}
      <p style={{ textAlign: "center", marginTop: 18, color: "#666" }}>
        Besoin d’aide ? Écrivez-moi :{" "}
        <a href="mailto:contact@maximeh.lu">contact@maximeh.lu</a>
      </p>
    </section>
  );
}